import React, { Component } from "react";
import { Card, Switch, Button, InputGroup, FormGroup, Icon } from "@blueprintjs/core";
import { BASE_API, AppToaster } from "../../utils/constants";
import UiDialog from '../../components-fm/UiDialog';
import "../../css/SuperAdminDashboard.scss";

class SuperAdminOrganizations extends Component {
  state = {

	};

	componentDidMount() {
		this.getData();
	}

	async getData() {
		// try {
		//   const res = await fetch(`${BASE_API}/api/admin/organizations/all`);
		//   const data = await res.json();
		//   this.setState({ organizations: data.organizations || [], loading: false });
		// } catch (err) {
		//   this.setState({ error: "Eroare la încărcarea organizațiilor", loading: false });
		// }
	}


	handleSearch = (e) => {
		this.setState({ searchTerm: e.target.value });

	};
	handleFilter = (filter) => {
		this.setState({ filter });
	};





	render() {


		// if (loading) return <p>Se încarcă...</p>;
		// if (error) return <p>{error}</p>;

		return (
			<>


				SETTINGS content





			</>
		);
	}
}

export default SuperAdminOrganizations;
